'use client';
import { useState } from 'react';
import BackTopBtn from './components/BackTopBtn';
import CustomerSupport from './components/CustomerSupport';
import FeedbackBtn from './components/FeedbackBtn';
import MessageBtn from './components/MessageBtn';
import style from './style.module.scss';

export interface Props {
  open?: boolean;
  onOpen: () => void;
}

const JDIFloatingToolbar = () => {
  const [isOpenMessage, setIsOpenMessage] = useState<boolean>(false);

  const handleOpenMessage = () => {
    closeCustomerService();
    setIsOpenMessage(true);
  };

  const handleOpenService = () => {
    setIsOpenMessage(false);
  };

  const handleOpenFeedback = () => {
    setIsOpenMessage(false);
    closeCustomerService();
  };

  const closeCustomerService = () => {
    if (window && (window as any).zE) {
      (window as any)?.zE('messenger', 'close');
    }
  };

  return (
    <div id='jdi-floating-toolbar' className={style.floatingToolbar}>
      <MessageBtn open={isOpenMessage} onOpen={handleOpenMessage} />
      <CustomerSupport onOpen={handleOpenService} />
      <FeedbackBtn onOpen={handleOpenFeedback} />
      <BackTopBtn />
    </div>
  );
};

export default JDIFloatingToolbar;
